<template>
    <div style="position: relative; overflow: hidden">
        <a
            href="https://yandex.ru/maps/org/rvm/136770817997/?utm_medium=mapframe&utm_source=maps"
            style="color: #eee; font-size: 12px; position: absolute; top: 0px"
            >РВМ</a
        ><a
            href="https://yandex.ru/maps/2/saint-petersburg/category/real_estate_agency/184107503/?utm_medium=mapframe&utm_source=maps"
            style="color: #eee; font-size: 12px; position: absolute; top: 14px"
            >Агентство недвижимости в Санкт‑Петербурге</a
        ><iframe
            src="https://yandex.ru/map-widget/v1/?ll=30.342197%2C59.957787&mode=search&oid=136770817997&ol=biz&z=17.52"
            width="100%"
            height="600"
            frameborder="1"
            allowfullscreen="true"
            style="position: relative"
        ></iframe>
    </div>
</template>
